import { PERFIS_CLIENTE } from '@/libs/perfilCliente';
import ability from '@/libs/acl/ability';

export function getCrmNav() {
  const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado') || '{}');
  const perfilNome = perfilLogado.perfil_acesso_nome || '';

  if (!perfilNome) return [];

  const isClient = PERFIS_CLIENTE.includes(perfilNome);

  const children = [];

  if (!isClient) {
    children.push(
      {
        title: 'Clientes',
        route: 'crm-clientes',
        icon: 'BriefcaseIcon',
        action: 'read',
        resource: 'MenuCrmClientes',
      },
      {
        title: 'Agenda',
        route: 'crm-agenda',
        icon: 'CalendarIcon',
        action: 'read',
        resource: 'MenuCrmAgenda',
      },
      {
        title: 'Oportunidades',
        route: 'crm-oportunidades',
        icon: 'TargetIcon',
        action: 'read',
        resource: 'MenuCrmOportunidades',
      },
      {
        title: 'Campanhas',
        route: 'crm-campanhas',
        icon: 'SendIcon',
        action: 'read',
        resource: 'MenuCrmCampanhas',
      },
      {
        title: 'Aniversariantes',
        route: 'crm-aniversariantes',
        icon: 'GiftIcon',
        action: 'read',
        resource: 'MenuCrmAniversariantes',
      },
      {
        title: 'Gamificação',
        route: 'gamification-campaigns',
        icon: 'AwardIcon',
        action: 'read',
        resource: 'MenuGamificacao',
      },
    );
  }

  children.push({
    title: 'Marketing',
    route: 'crm-marketing',
    icon: 'FolderIcon',
    action: 'read',
    resource: 'MenuCrmMarketing',
  });

  // Cabeçalho e grupo só aparecem se o perfil tem acesso a pelo menos um
  // módulo do CRM (senão o título "CRM" ficava órfão no menu).
  const temAlgumModulo = children.some((c) => {
    try { return ability.can(c.action, c.resource); } catch (e) { return false; }
  });
  if (!temAlgumModulo) return [];

  return [
    {
      // Título distinto do grupo "CRM" abaixo: o menu usa header/title como
      // :key e valores iguais geram "Duplicate keys detected".
      header: 'Módulo CRM',
      action: 'read',
      resource: 'Auth',
      // Parametrizado por tenant: CRM_ATIVO (ausente = ligado).
      tenantPref: 'crmAtivo',
    },
    {
      title: 'CRM',
      icon: 'UsersIcon',
      tenantPref: 'crmAtivo',
      children,
    },
  ];
}

export default getCrmNav();
